<!--
 * @Author: Lemon C
 * @Date: 2024-04-22 10:43:10
 * @LastEditTime: 2026-01-23 17:08:45
-->
<template>
    <div class="sup-bady">
        <DocsTypeSwitch class="top-type-switch" :currId="curr_switch_type" :switch_type="1" :title_name="'更新日志'" :needSerarch="true">
        </DocsTypeSwitch>
        <div class="docs-page">
            <DocsTree class="docs-tree" :request_gourp_list="eltree_group_list" :share_url_data="shareData" :tree_node_callback="tree_node_callback">
            </DocsTree>
            <UpdateComp
                class="docs-content"
                v-if="eltree_sel_data.id"
                :share_url_data="shareData"
                :comp_tree_node_id="eltree_sel_data.id"
                :comp_tree_node_tree_type="eltree_sel_data.treeType"
                :comp_tree_node_name="eltree_sel_data.name">
            </UpdateComp>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onBeforeMount, nextTick, getCurrentInstance } from 'vue';
import DocsTypeSwitch from '@/components/Docs/DocsTypeSwitch.vue';
import DocsTree from '@/components/Tree/DocsTree.vue';
import UpdateComp from '@/components/Update/UpdateComp.vue';

import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';

const message_store = useMessageStore();
const router_store = useRouterStore();
const { proxy } = getCurrentInstance();

const curr_switch_type = ref(proxy.$globalObj.docs_switch.update); //当前文档类型
const shareData = ref({}); //分享链接数据
const eltree_sel_data = ref({}); //目录树选中节点
const eltree_group_list = ref([
    { name: 'SDK', id: 'sdk', group: 10, treeType: proxy.$globalObj.docs_update_type.sdk },
    { name: '数据处理工具', id: 'tools', group: 76, treeType: proxy.$globalObj.docs_update_type.plugin },
    { name: '自动化转换平台', id: 'convertPlatform', group: 11, treeType: proxy.$globalObj.docs_update_type.platform },
    { name: '多终端查看工具', id: 'client', group: 90, treeType: proxy.$globalObj.docs_update_type.client },
]); //复合目录树

onBeforeMount(() => {
    let queryDate = proxy.$route.query;
    if (queryDate && queryDate.shareType && queryDate.shareType == 1) {
        shareData.value = queryDate;
        console.log('分享数据 -- ', queryDate);
    }
});

// MARK Tree  节点点击
const tree_node_callback = (data, treeList) => {
    eltree_sel_data.value = data;
    nextTick(()=>{
        message_store.sendMessage(message_store.M_E_TREE_LIST_UPDATE, { treeList: treeList });
    })
    let queryDate = proxy.$route.query;
    if (!(queryDate && queryDate.shareType && queryDate.shareType == 1 && queryDate.treeId && queryDate.treeId == data.id)) {
        router_store.configBrowserAddressRoute({ shareType: 1, treeId: data.id });
    }
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    background-color: var(--color-main-light-bg-white);

    .top-type-switch {
        position: absolute;
        top: 0;
        left: 0;
        z-index: var(--type-switch-z-index);
    }

    .docs-page {
        position: relative;
        margin-top: 80px;
        width: 100%;
        height: calc(100% - 80px);
        background-color: var(--color-main-light-bg-white);
        display: flex;
        overflow: hidden;

        .docs-tree {
            width: 23%;
        }

        .docs-content {
            position: relative;
            height: 100%;
            width: 100%;
            display: flex;
            padding-right: 48px;
            box-sizing: border-box;
        }
    }
}
</style>
